import raf from 'raf';

/**
 * Extends ResizeObserver, but requests an animation frame around
 * the default behavior (when changes occur).
 */
export class RafResizeObserver extends ResizeObserver {
  constructor(callback) {
    super((...args) => {
      raf(() => {
        callback(...args);
      });
    });
  }
}

/**
 * Replaces ResizeObserver with the RafResizeObserver
 */
export default () => {
  window.NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = RafResizeObserver;
};
